import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FuseCardComponent } from '@fuse/components/card';
import { MatButtonModule } from '@angular/material/button';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import { WebStorage } from 'app/core/shared-services/web.storage';

@Component({
  selector: 'app-upfront-payment',
  standalone: true,
  imports: [CommonModule, MatButtonModule, FuseAlertComponent, MatIconModule, FuseCardComponent],
  templateUrl: './upfront-payment.component.html',
  styleUrls: ['./upfront-payment.component.scss']
})
export class UpfrontPaymentComponent {

  @Input() checkoutProcessView: boolean = false;
  @Input() upFrontAmount: number = 0;
  @Input() leadId: number;

  private payNowResult: any;

  public alert: { type: FuseAlertType; message: string };
  public showAlert: boolean = false;
  


  /**
     * Constructor
     */

  constructor(
    private _sharedMethods: SharedMethodsModule,
    private _webStorage: WebStorage,
    @Inject(PLATFORM_ID) private platformId: any
  ){
  }

  // -----------------------------------------------------------------------------------------------------
    // @ Public Methods
    // 

  public async payNow() {
    const payNowData = {
      leadEntityId: this.leadId,
      pendingAmount: this.upFrontAmount,
      isPartialPayment: false,
      partialAmount: null,
      isForCardTokenisation: false
    }
    this.payNowResult = await this._sharedMethods.payNow(payNowData);

    if (this.payNowResult?.success && isPlatformBrowser(this.platformId)) {
      // only using payfast for now
      window.open(this.payNowResult.result[0].PaymentLink, '_top');
    } else {
      this.alert = {
        type: 'error',
        message: this.payNowResult?.error?.error?.Message,
      }
      this.showAlert = true;
    }

  }

}
